import ApiService from "@/core/services/ApiService";
import { Actions, APIEndpoints } from "@/store/enums/StoreEnums";
import {
  Module,
  Action,
  Mutation,
  VuexModule,
  config,
} from "vuex-module-decorators";

config.rawError = true;

@Module
export default class ProductModule extends VuexModule {
  @Action({ rawError: true })
  [Actions.GET_PRODUCTS]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(`/attorney/${APIEndpoints.PRODUCTS}/${APIEndpoints.LIST}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_PRODUCT_DETAILS](payload) {
    ApiService.setHeader(payload.selectedLocale || "en");
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.PRODUCTS}/${APIEndpoints.GET_DETAILS}`,
        payload
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.ADD_OR_UPDATE_PRODUCT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.PRODUCTS}/${APIEndpoints.UPDATE_DETAILS}`,
        payload
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.PUBLISH_PRODUCT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.PRODUCTS}/${APIEndpoints.PUBLISH_PRODUCT}`,
        payload
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.PAUSE_PRODUCT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.PRODUCTS}/${APIEndpoints.PAUSE_PRODUCT}`,
        payload
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_PRODUCT_QUESTIONS](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(`/${APIEndpoints.GET_PRODUCT_QUESTIONS}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_CATEGORIES_AS_TREE]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.PRODUCTS}/${APIEndpoints.TREE_CATEGORY}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_PRODUCTS_LIST](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.PRODUCTS}/${APIEndpoints.LIST}/${APIEndpoints.CATEGORY}/${payload.categoryId}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_PRODUCT_OFFERS](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.PRODUCTS}/${payload.productId}/${APIEndpoints.PRODUCT_OFFERS}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
